import regex from '../constants/regex';

app.constant('customValidator', {
  EMAIL_REGEX: regex.EMAIL_REGEX,
  EMAIL_MOBILE_REGEX: regex.EMAIL_MOBILE_REGEX,
});
